/**
 * @file   src/components/AiChat/AiWantAdTabs.js
 * @brief  Tab wrapper for AI Chat vs Manual Form in want ad creation
 * @date   February, 2026
 * @author Jake Hokinson
 *
 * INTEGRATION: See SETUP.md in the bundle root for how to wire this into CreateWantAd.js
 */
import React, { useState } from "react";
import AiChatPanel from "./AiChatPanel";

const AiWantAdTabs = ({ children, isEditing, onWantAdGenerated }) => {
  const [activeTab, setActiveTab] = useState(isEditing ? "manual" : "ai");

  // If editing an existing want ad, just show the manual form
  if (isEditing) {
    return <>{children}</>;
  }

  return (
    <div className="ai-wantad-container">
      <div className="ai-wantad-tabs">
        <button
          className={`ai-wantad-tab ${activeTab === "ai" ? "active" : ""}`}
          onClick={() => setActiveTab("ai")}
        >
          <span className="tab-icon">✨</span>
          Chat with AI
        </button>
        <button
          className={`ai-wantad-tab ${activeTab === "manual" ? "active" : ""}`}
          onClick={() => setActiveTab("manual")}
        >
          <span className="tab-icon">📝</span>
          Fill Out Manually
        </button>
      </div>

      {activeTab === "ai" ? (
        <AiChatPanel onWantAdGenerated={onWantAdGenerated} />
      ) : (
        <>{children}</>
      )}
    </div>
  );
};

export default AiWantAdTabs;
